import {QuoteBlockType} from 'campagne/types'
import React from 'react'
import {style} from 'util/campagne/style'
import {Theme} from 'views/campagne/theme'
import {Block} from '../blocks'

const styles = style('quoteblock')

const QuoteBlock: React.FC<QuoteBlockType> = ({text}) => {
	if (!text) return null
	return (
		<Block>
			<Theme.Quote class={styles}>{text}</Theme.Quote>
		</Block>
	)
}

export default QuoteBlock
